import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import {
  formatDateWithSuffix,
  formatFullTimestamp,
} from "../../../utils/formatTime";
import CopyToClipboard from "../../../components/utils/CopyToClipboard";
interface ListDetailsModalProps {
  onClose: () => void;
  list: {
    points: number;
    source: string;
    timestamp: string;
    activityType: string;
    description?: string;
    message?: string;
  };
}

const ListDetailsModal = ({ onClose, list }: ListDetailsModalProps) => {
  // console.log(list);
  return (
    <div className="fixed inset-0 font-sora flex justify-center items-start pt-16 overflow-auto pb-16 bg-black bg-opacity-75">
      <div className="bg-white dark:bg-[#1C2227] rounded-xl w-11/12 max-w-md relative">
        <div className="p-6">
          <div className="w-full flex justify-start gap-6 items-center">
            <button
              onClick={() => {
                onClose();
              }}
            >
              <BsArrowLeft className="text-black dark:text-white text-[20px]" />
            </button>
            <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
              Activity Details
            </h4>
          </div>

          <div className="mt-8 space-y-6">
            <section>
              <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-3">
                Summary
              </h5>
              <div className="space-y-1">
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Points Earned
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 font-semibold">
                    {list.points} points
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Source
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 font-semibold">
                    {list.source}
                  </span>
                </div>
                {list.description && (
                  <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                    <span className="text-gray-500 dark:text-gray-400 text-sm">
                      Description
                    </span>
                    <span className="text-gray-900 dark:text-gray-100 font-semibold">
                      {list.description}
                    </span>
                  </div>
                )}
                {list.message && (
                  <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                    <span className="text-gray-500 dark:text-gray-400 text-sm">
                      Message
                    </span>
                    <span className="text-gray-900 dark:text-gray-100 font-semibold">
                      {list.message}
                    </span>
                  </div>
                )}
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Status
                  </span>
                  <span className="text-[#03C668] bg-[#03C668]/10 p-2 rounded-lg font-semibold text-[13px]">
                    COMPLETED
                  </span>
                </div>
              </div>
            </section>

            <section>
              <h5 className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-3">
                Details
              </h5>
              <div className="space-y-1">
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Transaction Date
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 text-sm">
                    {formatDateWithSuffix(list.timestamp)}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Date & time
                  </span>
                  <span className="text-gray-900 dark:text-gray-100 text-sm">
                    {formatFullTimestamp(list.timestamp)}
                  </span>
                </div>
                <div className="flex justify-between flex-col items-start gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-gray-500 dark:text-gray-400 text-sm">
                    Activity Type
                  </span>
                  <CopyToClipboard text={list.activityType}>
                    <span className="text-gray-900 dark:text-gray-100 text-sm font-mono cursor-pointer">
                      {list.activityType}
                    </span>
                  </CopyToClipboard>
                </div>
              </div>
            </section>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-8 font-manrope bg-secondary_button text-white py-4 rounded-xl font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ListDetailsModal;
